<template>
  <RxkDialog
    v-model="show"
    width="480"
    title="加签"
    :is-loading="loading"
    @sure="handleSure"
    @close="handleClose"
  >
    <div class="tw-p-[16px]">
      <el-form ref="formRef" :rules="rules" :model="formState" label-position="top">
        <el-form-item label="加签方式" prop="addSignType">
          <el-radio-group style="width: 100%" v-model="formState.addSignType">
            <el-row style="width: 100%" :gutter="10">
              <el-col :span="12">
                <el-radio label="BEFORE">前加签</el-radio>
                <div class="type-tips">被加签人先处理，之后我处理</div>
              </el-col>
              <el-col :span="12">
                <el-radio label="AFTER">后加签</el-radio>
                <div class="type-tips">我同意提交，之后让被加签人处理</div>
              </el-col>
            </el-row>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="选择审批人" prop="operator">
          <MemberSingleSelection
            v-if="show"
            style="width: 100%"
            :data="memberCommonData"
            placeholder="选择成员"
            @sure="getOperator"
          />
        </el-form-item>
        <el-form-item label="审批意见" prop="remark" v-if="formState.addSignType === 'after'">
          <RxkInput v-model="formState.remark" show-word-limit type="textarea" maxlength="1000" />
        </el-form-item>
      </el-form>
    </div>
  </RxkDialog>
</template>
<script lang="ts" setup>
import { ref, computed, reactive, watch, nextTick } from 'vue'
import { RxkDialog } from '@/components/common/RxkDialog'
import { RxkInput } from '@/components/common'
import { ComponentType, ComponentUseSceneType } from '@/enums/preObjectManage'
import { getComponentTree } from '@/apis/common'
import { AuthBtn } from '@/components/business/FlowDeal/config'

const props = defineProps({
  modelValue: Boolean,
  info: Object
})
const emit = defineEmits(['update:modelValue', 'submit'])

const show = computed({
  get: () => {
    return props.modelValue
  },
  set: (val: any) => {
    emit('update:modelValue', val)
  }
})

const loading = ref(true)

function handleClose() {
  emit('update:modelValue', false)
}

// form相关
watch(
  () => props.modelValue,
  val => {
    if (val) {
      nextTick(() => {
        if (!formRef.value) return
        formRef.value.resetFields()
        getMemberData()
      })
    }
  }
)
const formState = reactive({
  addSignType: '',
  operator: '',
  remark: ''
})
const formRef = ref()
const rules = {
  addSignType: [{ required: true, message: '请选择加签类型', trigger: 'change' }],
  operator: [{ required: true, message: '请选择审批人', trigger: 'change' }]
}

async function handleSure(fn: Fn = () => {}) {
  if (!formRef.value) return
  await formRef.value.validate(async (valid: any) => {
    if (valid) {
      emit('submit', {
        action: AuthBtn.ADD_SIGN,
        comment: formState.remark,
        type: formState.addSignType,
        operator: formState.operator
      })
      handleClose()
      fn()
    } else {
      fn()
    }
  })
}

// 人员组件
const memberCommonData = ref<Recordable>()

const commonParams = {
  useSceneType: ComponentUseSceneType.paas,
  memberType: ComponentType.person
}

async function getMemberData() {
  const res = await getComponentTree({
    showResign: false,
    checkChildFlag: true,
    ...commonParams
  })
  memberCommonData.value = res
}

function getOperator(data: any) {
  const { userInfoList } = data
  if (userInfoList.length) {
    formState.operator = userInfoList[0].id
  } else {
    formState.operator = ''
  }
}
</script>
<style lang="scss" scoped>
.type-tips {
  color: #999999;
  font-size: 12px;
  line-height: 20px;
  margin-top: -10px;
  padding-left: 22px;
}
</style>
